import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useFetch } from "../../hook/useFetch";
import { logout } from "../../services";

export const DropdownLoggedIn = ({ setDropDown, setSideNav, sideNav }) => {
  const navigate = useNavigate();

  const cbid = JSON.parse(sessionStorage.getItem("cbid"));

  const { data: user, error } = useFetch(`${process.env.REACT_APP_HOST}/600/users/${cbid}`);


 error && toast.error(error, {position: 'bottom-center'})

  function handleLogout() {
    logout();
    navigate("/");
    setDropDown(false);
  }

  function handleDrop() {
    setSideNav(!sideNav);
    setDropDown(false);
  }

  return (
    <div
      id="dropdownAvatar"
      className="select-none z-40 absolute other:top-[6.6rem] other:w-[20rem] res880:top-10 top-10 right-0 w-44 bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600"
    >
      <div className="py-3 px-4 text-sm text-gray-900 dark:text-white">
        <div className="font-medium truncate">{user.username}</div>
      </div>
      <ul
        className="py-1 text-sm text-gray-700 dark:text-gray-200"
        aria-labelledby="dropdownUserAvatarButton"
      >
        <li>
          <Link
            onClick={handleDrop}
            to="/products"
            className="block py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
          >
            All eBooks
          </Link>
        </li>
        <li>
          <Link
            onClick={handleDrop}
            to="/dashboard"
            className="block py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
          >
            Dashboard
          </Link>
        </li>
      </ul>
      <div className="py-1">
        <span
          onClick={handleLogout}
          className="cursor-pointer block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
        >
          Log out
        </span>
      </div>
    </div>
  );
};
